"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceState = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icons/Icon");
const ResourceState = function ({ state, message, handleReload, showButton = true }) {
    const RetryButton = (react_1.default.createElement("button", { type: "button", onClick: handleReload, className: "flex flex-row items-center justify-center gap-3 bg-black bg-opacity-10 h-9 mt-3 rounded text-md font-bold text-gray-700 py-2 px-3" },
        react_1.default.createElement(Icon_1.Icon, { icon: state === 'empty' ? 'back' : 'retry', "aria-hidden": true }),
        state === 'empty' ? 'Back to source list' : 'Try again'));
    return (react_1.default.createElement("div", { className: "squiz-gb-scope flex flex-col items-center rounded-lg py-8 bg-white h-204 gap-3" },
        react_1.default.createElement(Icon_1.Icon, { icon: state, "aria-hidden": true }),
        react_1.default.createElement("span", { className: "text-md text-gray-800 font-semibold leading-5" }, state === 'empty' ? 'There are no items to display' : message),
        showButton && RetryButton));
};
exports.ResourceState = ResourceState;
